module.exports = __webpack_public_path__ + "static/media/notification-icon.ad8c5d07.svg";